import { useLocation } from 'react-router-dom';
import { __ } from '@wordpress/i18n';

const VideoPopup = ({ isVideoPopupVisible, setIsVideoPopupVisible }) => {
    const plugin_url = nxtext_ajax_object?.nxtex_url || "";
    const location = useLocation();
    const isDashboardPage = location.pathname.startsWith('/');

    const handleClose = () => {
        setIsVideoPopupVisible(false);
    };

    if (!isDashboardPage || !isVideoPopupVisible) return null;

    return (
        <>
            <div className="nxt_whitlabel_overlay" onClick={handleClose}></div>

            <div className="nxt_ext_whitlabel_popup nxt_video_popup">
                <img 
                    className="nxtext_close_icon"
                    src={`${plugin_url}assets/svg/nxt_close_icon.svg`} 
                    draggable={false}
                    onClick={handleClose}
                />
                <h4 className="nxtext_primary_heading">
                    {__("AI Integration for WordPress Blocks, New Code Snippets Update & WooCommerce Security", 'the-plus-addons-for-block-editor')}
                </h4>
                <iframe
                    src="https://www.youtube.com/embed/r8-B6Ozlekk?autoplay=1&mute=1&controls=1&rel=0&playsinline=1"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen>
                </iframe>
            </div>
        </>
    );
};

export default VideoPopup;